import { createAsyncThunk } from "@reduxjs/toolkit";
import { BackOfficeService } from "../../../api";

export const search = createAsyncThunk("dsi/search", ({ filters, page, limit, token }) =>
	BackOfficeService.getPlatfortmUsers({ ...(filters || {}) }, { page, limit }, token)
);
